export const AbortNavigationMessage = 'AbortNavigation'
